const adjustmentConfig = {
    adjustment_state:       false,
    adjustment_text_true:   '',
    adjustment_text_false:  '',
    adjustment_modal:       false,
};

export default adjustmentConfig;
